var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefensive1 = function SvgDefensive1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#204969",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.452 26.79c-4.762-.343-9.392-2.103-14.552-5.52a1.62 1.62 0 0 0-1.933.104c-3.93 3.178-8.79 5.006-14.42 5.415A1.7 1.7 0 0 0 25 28.497V40.8c0 7.944 4.513 15.292 11.506 18.708l4.778 2.323c.217.12.467.17.716.17.25 0 .483-.05.716-.17l4.778-2.323C54.471 56.09 59 48.743 59 40.8V28.5c0-.906-.683-1.64-1.548-1.71M45.846 45.874c.15 1.026-.616 1.964-1.648 1.964h-4.429c-1.016 0-1.797-.94-1.648-1.964l.8-5.28a4.35 4.35 0 0 1-1.082-2.87c0-2.717 2.43-4.834 5.228-4.135 1.399.342 2.564 1.521 2.947 2.956.398 1.572-.033 3.04-.95 4.067z"
  })));
};
export default SvgDefensive1;